import { utils, writeFileXLSX, read } from "xlsx";
import { setSnackbarDetails } from "../redux/AuthReducer/AuthSlice";
import { apiClient } from "./apiClient";

export const formatDateOnly = (date: Date | null) => {
  if (!date) return "";

  return date.toLocaleDateString("en-CA");
};

export const formatTime = (date: Date | null) => {
  if (!date) return "";

  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const parseTimeToDate = (timeString: string | null) => {
  if (!timeString) return null;

  const today = new Date();

  const parts = timeString.split(":");

  const hours = Number(parts[0]);
  const minutes = Number(parts[1]);
  const seconds = parts[2] ? Number(parts[2]) : 0; // ✅ default to 0

  today.setHours(hours, minutes, seconds, 0);

  return today;
};

export const exportToExcel = (
  headers: string[],
  data: any[],
  pageName: string,
) => {
  // Create worksheet with controlled header order
  const worksheet = utils.json_to_sheet(data, {
    header: headers,
    skipHeader: false, // automatically creates header row
  });

  // Create workbook
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, pageName);

  // Download file
  writeFileXLSX(workbook, pageName);
};

export const downloadXMLTemplateFormat = () => {
  const link = document.createElement("a");
  link.href = "/Employee_Bulk_Create_Template.xlsx"; // exact name
  link.download = "Employee_Bulk_Create_Template.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export function getTermCodeList() {
  let termCodes = JSON.parse(
    localStorage.getItem("oc_all_in_termCodes") || "[]",
  );
  return termCodes;
}
